import _ from 'lodash';
import moment from 'moment';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { ROW_TYPES } from '../../properties/Properties';

const DAY_IN_MINUTES = 1440;

function formatTestInterval(intervalAsObj) {
    if (_.isEmpty(intervalAsObj)) {
        return '';
    }

    const hoursFmt = intervalAsObj.hours ? `${intervalAsObj.hours}h ` : '';
    const minutesFmt = intervalAsObj.minutes ? `${intervalAsObj.minutes}m` : '';
    return `${hoursFmt}${minutesFmt}`;
}

function testIntervalToHoursMinutes(intervalInSeconds) {
    const savedIntervalUnit = 'seconds';
    const emptyValue = '';
    const testDuration = moment.duration(intervalInSeconds, savedIntervalUnit);

    // If we are at a day, then just set the hours.
    if (testDuration.asMinutes() === DAY_IN_MINUTES) {
        return {
            hours: testDuration.asHours(),
            minutes: emptyValue,
        };
    }

    return {
        hours: testDuration.hours() || emptyValue,
        minutes: testDuration.minutes() || emptyValue,
    };
}

export const runIntervalProperty = {
    title: i18n._(t`Run Interval`),
    hasValue: (data) => _.isNumber(_.get(data, 'scheduling.interval')),
    type: ROW_TYPES.FUNCTION,
    mapper: (data) => {
        const interval = _.get(data, 'scheduling.interval');
        return formatTestInterval(testIntervalToHoursMinutes(interval));
    },
};
